<main class="min-dvh-100 w-100 d-flex justify-content-center align-items-center bg-white px-5">
    <section class="w-100 mx-auto d-flex flex-column justify-content-center bg-white" aria-label="Recuperar senha">
        <div class="w-100 py-4">
            <div class="text-center mb-4">
                <div class="fw-bold lh-1">Ariel PWA</div>
                <h1 class="mb-2 fw-bold">Recuperar Senha</h1>
                <p class="text-body-secondary mb-0">
                    Informe seu email para receber as instruções.
                </p>
            </div>

            <form #f="ngForm" (ngSubmit)="onSubmit(f)" novalidate>
                <div class="mb-3">
                    <input id="recover-password-email" #emailModel="ngModel" [(ngModel)]="email" name="email"
                        type="email" autocomplete="email" inputmode="email" class="form-control form-control-lg auth-field"
                        placeholder="Email cadastrado" required [pattern]="emailPattern"
                        [class.auth-field-valid]="isEmailStructurallyValid(email)"
                        [class.auth-field-invalid]="(f.submitted || emailModel.touched || hasTypedEmail()) && !isEmailStructurallyValid(email)"
                        [class.is-invalid]="(f.submitted || emailModel.touched || hasTypedEmail()) && !isEmailStructurallyValid(email)" />
                    @if ((f.submitted || emailModel.touched || hasTypedEmail()) && !isEmailStructurallyValid(email)) {
                    <div class="invalid-feedback d-block">
                        Informe um email válido para continuar.
                    </div>
                    }
                </div>

                <button class="btn btn-primary btn-lg w-100" type="submit"
                    [disabled]="loading || !isEmailStructurallyValid(email)">
                    @if (loading) {
                    <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                    <span>Enviando...</span>
                    } @else {
                    <span>Enviar email</span>
                    }
                </button>

                <a class="btn btn-link w-100 mt-3" routerLink="/login">
                    Voltar para o login
                </a>
            </form>
        </div>
    </section>
</main>
